// AI 模型設定（調查 + 守門角色的供應商/模型定義）— React Admin 資源字串（子計劃 20）。
// 對應 /api/backend/ai-troubleshooting/model-configs。
export const aiModelConfigs = {
  name: 'AI 模型設定',
  fields: {
    id: 'ID',
    provider: '供應商',
    modelName: '模型名稱',
    displayName: '顯示名稱',
    gatewayRoute: '閘道路徑',
    role: '角色',
    isActive: '啟用',
    isDefault: '預設',
    default: '預設',
    params: '參數（JSON）',
    createdAt: '建立時間',
    updatedAt: '更新時間',
  },
  sections: {
    identity: '識別資訊',
    behaviour: '行為設定',
    params: '參數',
  },
  roles: {
    investigation: '調查',
    gate: '守門',
  },
  filters: {
    role: '角色',
    isActive: '狀態',
    active: '啟用',
    inactive: '停用',
  },
  actions: {
    setDefault: '設為預設',
  },
  list: {
    title: 'AI 模型設定',
  },
  create: {
    title: '新增模型設定',
    subtitle: '新增一個 AI 模型設定',
    backToList: '返回模型設定列表',
  },
  edit: {
    title: '編輯模型設定',
    subtitle: '調整此 AI 模型設定',
    backToList: '返回模型設定列表',
  },
  helpers: {
    modelName: '供應商的模型 ID（例如 glm-4-plus、qwen-max）。',
    displayName: '在重播選擇器中顯示的人類可讀標籤。',
    gatewayRoute: '選填的 AI 閘道路徑/基礎端點。留空則使用預設值。',
    isActive: '停用的設定不會出現在重播選擇器中，但仍會列於此處。',
    isDefault: '每個角色最多只能有一個預設值。',
    defaultWarning: '每個角色僅允許一個預設模型；儲存後將取代所選角色現有的預設值。',
    params: '模型參數的 JSON 物件（temperature、max_tokens 等）。',
  },
  errors: {
    invalidJson: 'JSON 格式無效。請先修正語法再儲存。',
    paramsNotObject: '參數必須是 JSON 物件（例如 { "temperature": 0.2 }）。',
    conflict: '已存在使用相同供應商 + 模型 + 角色的模型設定，或發生預設值衝突。請檢查後再試一次。',
    inUse: '此模型是其角色的預設值；請先設定另一個預設值。',
    defaultConflict: '因衝突而無法將此模型設為預設值。請重新整理後再試一次。',
    defaultFailed: '無法將此模型設為預設值。',
  },
  notifications: {
    created: '已成功建立模型設定。',
    updated: '已成功更新模型設定。',
    deleted: '已成功刪除模型設定。',
    defaultSet: '已更新預設模型。',
    error: {
      create: '建立模型設定失敗。',
      update: '更新模型設定失敗。',
      delete: '刪除模型設定失敗。',
    },
  },
};
